/* eslint-disable @typescript-eslint/no-unsafe-argument */
type FlattenedRow = { key: string; value: string; depth: number };

export const flattenJson = (
  obj: Record<string, any>,
  depth = 0,
  prefix = ''
): FlattenedRow[] => {
  return Object.entries(obj).flatMap(([key, value]) => {
    const fullKey = prefix ? `${prefix}.${key}` : key;
    if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
      return [
        { key, value: '▼', depth },
        ...flattenJson(value, depth + 1, fullKey),
      ];
    }
    if (Array.isArray(value)) {
      return [
        { key, value: '', depth },
        ...value.flatMap((item, index) =>
          typeof item === 'object' && item !== null
            ? [
                { key: `[${index}]`, value: '', depth: depth + 1 },
                ...flattenJson(item, depth + 2, `${fullKey}[${index}]`),
              ]
            : [{ key: `[${index}]`, value: String(item), depth: depth + 1 }]
        ),
      ];
    }
    return [{ key, value: value === null ? 'null' : String(value), depth }];
  });
};
